import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d2dc924"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "hd-c-hub-gallery-grid__details" }
const _hoisted_3 = { class: "hd-c-hub-gallery-grid__meta" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "hd-c-hub-gallery-grid__meta-reactive"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_image_svg = _resolveComponent("base-image-svg")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_overlay_module = _resolveComponent("overlay-module")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
			`hd-c-hub-gallery-grid`,
			`hd-c-hub-gallery-grid__${_ctx.view}`
		])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datum, (endpoint, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["hd-c-hub-gallery-grid__item", { 'is-reactive': endpoint.reactive === 'true' }]),
        onClick: ($event: any) => (_ctx.processClick(endpoint))
      }, [
        (_ctx.checkEndpointReactive(endpoint.reactive === 'true'))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([
					'hd-c-hub-gallery-grid__container',
					{ 'is-active': _ctx.visitedEndpoints.includes(endpoint.endpointId) }
				])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["hd-c-hub-gallery-grid__image", endpoint.endpointId])
              }, null, 2),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_lyra_asset, {
                  class: "hd-c-hub-gallery-grid__title",
                  "asset-key": `endpoint-${endpoint.endpointId}-title`
                }, null, 8, ["asset-key"]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_base_image_svg, {
                    class: "hd-c-hub-gallery-grid__meta-svg",
                    source: _ctx.requireSvgSource(endpoint.type)
                  }, null, 8, ["source"]),
                  _createElementVNode("div", {
                    class: "hd-c-hub-gallery-grid__meta-label",
                    innerHTML: endpoint.meta
                  }, null, 8, _hoisted_4),
                  (endpoint.reactive === 'true')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_base_image_svg, {
                          class: "hd-c-hub-gallery-grid__meta-reactive-svg",
                          source: require('!html-loader!../assets/icons/reactive.svg')
                        }, null, 8, ["source"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    }), 128)),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.overlay)
          ? (_openBlock(), _createBlock(_component_overlay_module, { key: 0 }, {
              footer: _withCtx(() => [
                _createVNode(_component_base_button, {
                  callback: _ctx.processOverlay,
                  modifier: "secondary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lyra_asset, {
                      class: "hd-c-hub-gallery-grid__overlay-button",
                      "asset-key": "popup-disclaimer-button-back"
                    })
                  ]),
                  _: 1
                }, 8, ["callback"]),
                _createVNode(_component_base_button, {
                  callback: _ctx.navigateToEndpointId,
                  callbackString: _ctx.overlay
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lyra_asset, {
                      class: "hd-c-hub-gallery-grid__overlay-button",
                      "asset-key": "popup-disclaimer-understand"
                    })
                  ]),
                  _: 1
                }, 8, ["callback", "callbackString"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_lyra_asset, {
                  class: "hd-c-hub-gallery-grid__overlay-content",
                  "asset-key": `popup-${_ctx.overlay}-text`
                }, null, 8, ["asset-key"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}